import React from "react"
import TypographyComponent from "../../../Typography/ThypographyComponent"

interface TitleProps {
    title: string;
}

const DashboardTitleComponent = (props: TitleProps) => {
    return <TypographyComponent
        variant="h1" fontWeight="bold"
        sx={{
            // Tipografia
            fontFamily: '"Font 7", sans-serif',
            fontWeight: 700,
            fontSize: '30px',
            lineHeight: '36px',
            letterSpacing: '0em',

            // Alinhamento
            display: 'flex',
            alignItems: 'center',
            verticalAlign: 'middle',

            // Estética
            color: 'text.primary',
            textTransform: 'none',
        }}
    >
        {props.title}
    </TypographyComponent>
}

export default DashboardTitleComponent;